// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"f914d456","347":"0c0054c1","453":"a4631182","550":"cca29182","565":"2dd846b7","974":"d3e9c4b6"}[chunkId] + ".chunk.js";
};